'use strict'
import Axios, {AxiosInstance} from "axios";

export class EligibilityService {
  private _api!: AxiosInstance;

  constructor() {
    this._api = Axios.create({
      baseURL: process.env.VUE_APP_ECE_API_URL,
      responseType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-api-key': 'eaQSPYWOqAbDOpjX3zFC2bDJvh6z7wB3wV888d25'
      }
    });
  }

  async getEligibilityIncome(workflowId: string): Promise<number> {
    // The nocache below is an attemt to fix a safari issue where the eligibility income doesn't appear be fetching
    const result = await this._api.get<number>(`Eligibility/IncomeAmount/${workflowId}?nocache=${new Date().getTime()}`)
    return result.data;
    }

  async postEligibility(workflowId: string, isEligible: boolean): Promise<boolean> {
    const data = {
      workflowid: workflowId,
      eligible: isEligible
    }
    const response =  await this._api.post<boolean>('Eligibility/EligibleEvent', data);
    return response.data;
  }
}
